(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ohme-savings-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ohme-savings-calculator')) {
    class OhmeSavingsCalculator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        this.slider = this.querySelector(
          '[data-mileage-slider]'
        );

        this.vehicleButtons = Array.from(
          this.querySelectorAll('[data-vehicle]')
        );

        if (!this.slider || !this.vehicleButtons.length) {
          return;
        }

        const requestedVehicle =
          this.dataset.defaultVehicle || 'small';

        const startingButton =
          this.vehicleButtons.find(
            (button) =>
              button.dataset.vehicle === requestedVehicle
          ) || this.vehicleButtons[0];

        this.activeVehicle =
          startingButton.dataset.vehicle;

        this.setActiveVehicle(startingButton);

        this.vehicleButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.activeVehicle =
              button.dataset.vehicle;

            this.setActiveVehicle(button);
            this.updateCalculator();
          });
        });

        this.slider.addEventListener('input', () => {
          this.updateCalculator();
        });

        this.updateCalculator();
      }

      setActiveVehicle(activeButton) {
        this.vehicleButtons.forEach((button) => {
          const isActive = button === activeButton;

          button.classList.toggle(
            'is-active',
            isActive
          );

          button.setAttribute(
            'aria-pressed',
            isActive ? 'true' : 'false'
          );
        });
      }

      parseNumber(value, fallback) {
        const parsed = Number.parseFloat(
          String(value || '').replace(',', '.')
        );

        return Number.isFinite(parsed)
          ? parsed
          : fallback;
      }

      formatMoney(value) {
        return new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(Math.round(value));
      }

      formatNumber(value, maximumDigits = 1) {
        return new Intl.NumberFormat('en-GB', {
          minimumFractionDigits: 0,
          maximumFractionDigits: maximumDigits
        }).format(value);
      }

      formatMileageShort(mileage) {
        const thousands = mileage / 1000;

        return Number.isInteger(thousands)
          ? `${thousands}k`
          : `${thousands.toFixed(1)}k`;
      }

      setText(selector, value) {
        const element = this.querySelector(selector);

        if (element) {
          element.textContent = value;
        }
      }

      setBar(selector, value, maximum) {
        const element = this.querySelector(selector);

        if (!element || maximum <= 0) {
          return;
        }

        const percentage = Math.max(
          2,
          Math.min(100, (value / maximum) * 100)
        );

        element.style.width = `${percentage}%`;
      }

      updateCalculator() {
        const mileage = this.parseNumber(
          this.slider.value,
          5000
        );

        const selectedVehicle =
          this.vehicleButtons.find(
            (button) =>
              button.dataset.vehicle ===
              this.activeVehicle
          ) || this.vehicleButtons[0];

        /*
          Ohme-style vehicle efficiency values:

          Small:  4 miles per kWh
          Medium: 3 miles per kWh
          Large:  2 miles per kWh
        */
        const efficiency = this.parseNumber(
          selectedVehicle.dataset.efficiency,
          4
        );

        const petrolPrice = this.parseNumber(
          this.dataset.petrolPrice,
          1.58
        );

        const petrolMpg = this.parseNumber(
          this.dataset.petrolMpg,
          40
        );

        const standardRate = this.parseNumber(
          this.dataset.standardRate,
          26.1
        );

        const smartRate = this.parseNumber(
          this.dataset.smartRate,
          8
        );

        /*
          UK petrol calculation:

          miles divided by MPG gives imperial gallons.
          One imperial gallon equals 4.54609 litres.
        */
        const imperialGallons =
          mileage / petrolMpg;

        const petrolLitres =
          imperialGallons * 4.54609;

        const petrolCost =
          petrolLitres * petrolPrice;

        /*
          EV charging calculation:

          miles divided by miles/kWh gives annual kWh.
        */
        const annualKwh =
          mileage / efficiency;

        const standardCost =
          annualKwh * (standardRate / 100);

        const smartCost =
          annualKwh * (smartRate / 100);

        const annualSaving =
          Math.max(0, petrolCost - smartCost);

        const monthlySaving =
          annualSaving / 12;

        const minimumMileage = this.parseNumber(
          this.slider.min,
          1000
        );

        const maximumMileage = this.parseNumber(
          this.slider.max,
          20000
        );

        const sliderPosition =
          ((mileage - minimumMileage) /
            (maximumMileage - minimumMileage)) *
          100;

        this.style.setProperty(
          '--range-position',
          `${sliderPosition}%`
        );

        this.slider.style.setProperty(
          '--range-position',
          `${sliderPosition}%`
        );

        this.slider.setAttribute(
          'aria-valuetext',
          `${this.formatNumber(
            mileage,
            0
          )} miles per year`
        );

        this.setText(
          '[data-mileage-output]',
          this.formatMileageShort(mileage)
        );

        this.setText(
          '[data-mileage-full]',
          `${this.formatNumber(
            mileage,
            0
          )} miles`
        );

        this.setText(
          '[data-savings]',
          this.formatMoney(annualSaving)
        );

        this.setText(
          '[data-monthly-saving]',
          this.formatMoney(monthlySaving)
        );

        this.setText(
          '[data-petrol-cost]',
          this.formatMoney(petrolCost)
        );

        this.setText(
          '[data-standard-cost]',
          this.formatMoney(standardCost)
        );

        this.setText(
          '[data-smart-cost]',
          this.formatMoney(smartCost)
        );

        this.setText(
          '[data-petrol-mpg-label]',
          this.formatNumber(petrolMpg)
        );

        this.setText(
          '[data-petrol-price-label]',
          new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(petrolPrice)
        );

        this.setText(
          '[data-standard-rate-label]',
          this.formatNumber(standardRate)
        );

        this.setText(
          '[data-smart-rate-label]',
          this.formatNumber(smartRate)
        );

        this.setBar(
          '[data-petrol-bar]',
          petrolCost,
          petrolCost
        );

        this.setBar(
          '[data-standard-bar]',
          standardCost,
          petrolCost
        );

        this.setBar(
          '[data-smart-bar]',
          smartCost,
          petrolCost
        );
      }
    }

    customElements.define(
      'ohme-savings-calculator',
      OhmeSavingsCalculator
    );
  }

  } catch(e) { console.error(e); }
})();
})();
